/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoCircleIcon16Light = forwardRef('InfoCircleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 7.1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V10h.5a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1H7V7.6h-.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M7.25 5.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 7.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM7.5 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
